import { render, staticRenderFns } from "./PpeIcon.vue?vue&type=template&id=2e9d3e3c&"
import script from "./PpeIcon.vue?vue&type=script&lang=js&"
export * from "./PpeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports